import React, { useState, useEffect } from 'react';
import Title from '../../../Text/Title/Title';
import { Button, Col, Form, FormGroup, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { TableContainer, Paper, TableCell, TableRow, Table, TableHead, TableBody } from '@mui/material';
import useApiRequests from '../../../../hooks/useApiRequests.tsx';
import { useNotification } from '../../../../hooks/useNotification';
import { IBoard } from '../../../../interfaces/IBoard.tsx';
import { FaPen, FaTrash } from 'react-icons/fa6';


function Boards(): React.ReactElement {
  const { notify } = useNotification();

	const { getBoards } = useApiRequests();
	
	const [boards, setBoards] = useState<IBoard[]>([]);
  const [pageItens, setPageItens] = useState<IBoard[]>([]);
	const [pagination, setPagination] = useState({
    data: [],
    page: 0,
    itemsPerPage: 25,
    totalPages: 0,
  });

	//Funções

	useEffect(() => {
    const startIndex = pagination.page * pagination.itemsPerPage;
    const endIndex = startIndex + pagination.itemsPerPage;
    const slicedItens =
      pagination.data && pagination.data.slice(startIndex, endIndex);
      setPageItens(slicedItens||[]);
  }, [pagination]);


  useEffect(() => {
      fetchData();
  }, []);


  const fetchData = async () => {
    try{
      const data = await getBoards();
      if(data.success){
        const totalPages = Math.ceil(
          data.data.length / pagination.itemsPerPage
        );

        // Update pagination data
        setPagination((prevPagination) => ({
          ...prevPagination,
          data: data.data,
          totalPages,
        }));

        const startIndex = pagination.page * pagination.itemsPerPage;
        const endIndex = startIndex + pagination.itemsPerPage;
        const slicedItens = data.data && data.data.slice(startIndex, endIndex);
        setPageItens(slicedItens);
        setBoards(data.data);
      }else{
        notify("Ocorreu um erro ao buscar os dados", {type: "error"});
      }
    }catch(error){
      notify(error, {type: "error"});
    }
  };

	const handleNewBoard = () => {
		window.location.href = "board/edit/new";
	};

	const handleEditItem = (id: string) => {
		window.location.href = `/board/edit/${id}`;
	};


	return (
		<div className='page-container'>
			<div className='d-flex flex-wrap justify-content-between'>
				<div className="title-and-subtitle">
					<Title>Quadros</Title>
				</div>
				<Button color="success" style={{height: "48px"}} onClick={() => handleNewBoard()}>Novo Quadro</Button>
			</div>
			<div className="mt-5">
				<TableContainer component={Paper} className="mb-5">
					<Table aria-label="collapsible table">
						<TableHead>
						<TableRow>
							<TableCell className="th-text" >Nome</TableCell>
							<TableCell/>
							<TableCell/>                    
						</TableRow>
						</TableHead>
						<TableBody>
						{pageItens.length > 0 && pageItens.map((item, index) => {
							return (
							<TableRow key={index} sx={{ '& > *': { borderBottom: 'unset' } }} onDoubleClick={() => handleEditItem(item.id||"")}>
								<TableCell>{item.name}</TableCell>
								<TableCell align="right" width={20}>
								<FaPen
									className="pointer"
									color="#0d6efd"
									data-tooltip-id="edit-dropdown"
									data-tooltip-content="Editar"
									data-tooltip-place="top"
									onClick={() => handleEditItem(item.id||"")}
								/>
								</TableCell>
								<TableCell align="right" width={20}>
								{/* <FaTrash
									className="pointer"
									color="#ff5e00"
									onClick={() => {
									setItemToDelete(item.id||"");
									setDeleteModal(!deleteModal);
									}}
									data-tooltip-id="delete-dropdown"
									data-tooltip-content="Deletar"
									data-tooltip-place="top"
								/> */}
								</TableCell>
							</TableRow>
							)})}
						</TableBody>
					</Table>
				</TableContainer>
			</div>
		</div>
	);
}

export default Boards;
